import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { getCurrentInstance, ref, toRefs, watch } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import Steps from '@/client/components/_atoms/Steps.vue'
import { CAMPAIGN_STATUS } from '@/client/constant'
import { useInstagramScenarioEditorStore } from '@/client/features/instagram_instantwin_prize/hooks/instagramScenarioEditorStore'

import StepFollowCheck from './StepFollowCheck.vue'
import StepLottery from './StepLottery.vue'
import StepMessage from './StepMessage.vue'
import StepResult from './StepResult.vue'

interface Emits {
  (e: 'close'): void
  (e: 'saved'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramScenarioEditorDialog',
  props: {
  visible: {
    type: Boolean,
    required: true
  },
  prizeId: {
    type: Number,
    default: null
  },
  campaignStatus: {
    type: Number,
    default: null
  }
},
  emits: ["close", "saved"],
  setup(__props, { expose, emit }: { emit: ({
  (e: 'close'): void
  (e: 'saved'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;

// @ts-nocheck TODO: 既存の型エラーを解消したら外す
const { proxy } = getCurrentInstance() as {
  proxy: {
    $notify: (arg: { title: string; customClass: string; duration: number }) => void
  }
}



// Destructure props for template use
const { visible, prizeId, campaignStatus } = toRefs(props)



// Store
const store = useInstagramScenarioEditorStore()
const { currentStep, hasCurrentStepErrors } = storeToRefs(store)

// State
const loading = ref(false)

// ステップラベル
// デザイン仕様: 「フォローチェック」は「フォロー」+改行、「当落メッセージ」は「当落」+改行。
// Element UI の el-step は title をテキストとして描画するため、改行制御は '\n'+ white-space: pre-line でする。
const stepLabels = ['フォロー\nチェック', 'メッセージ', '抽選中', '当落\nメッセージ']

// Methods
const fetchScenarioData = async () => {
  if (!prizeId.value) {
    return
  }

  try {
    loading.value = true
    await store.open(prizeId.value)
  } catch {
    proxy.$notify({
      title: 'シナリオデータの読み込みに失敗しました。',
      customClass: 'danger',
      duration: 5000
    })
  } finally {
    loading.value = false
  }
}

const isCampaignRunning = (status: number | null): boolean => {
  if (status === null) {
    return false
  }
  return [
    CAMPAIGN_STATUS.BEFORE_COLLECTION,
    CAMPAIGN_STATUS.DURING_COLLECTION,
    CAMPAIGN_STATUS.DURING_FINAL_COLLECTION,
    CAMPAIGN_STATUS.COLLECTION_COMPLETED
  ].includes(status)
}

const handleClose = () => {
  // 未保存の変更がある場合、確認ダイアログを表示
  if (store.hasUnsavedChanges) {
    const confirmClose = window.confirm('編集内容が保存されていません。ダイアログを閉じますか？')
    if (!confirmClose) return

    // 変更を破棄してダイアログを閉じる
    store.close()
    emit('close')
  } else {
    // 変更がない場合、そのまま閉じる
    store.close()
    emit('close')
  }
}

const handleNext = () => {
  // バリデーション実行
  const isValid = store.validateCurrentStep()

  // バリデーション成功時のみ次のステップへ遷移
  if (isValid) {
    store.goToNextStep()
  }
}

const handleBack = () => {
  // 前のステップに戻る（バリデーションなし）
  store.goToPreviousStep()
}

const handleSave = async () => {
  // バリデーション実行
  const isValid = store.validateCurrentStep()

  if (!isValid) {
    return
  }

  try {
    loading.value = true
    await store.save()

    proxy.$notify({
      title: 'シナリオを保存しました。',
      customClass: 'success',
      duration: 5000
    })

    emit('saved')
    emit('close')
  } catch {
    proxy.$notify({
      title: 'シナリオの保存に失敗しました。',
      customClass: 'danger',
      duration: 5000
    })
  } finally {
    loading.value = false
  }
}

const handleCancel = () => {
  // キャンセルボタンも同じ確認ロジックを使用
  handleClose()
}

// Watch
watch(visible, newValue => {
  if (newValue && prizeId.value) {
    store.setCampaignRunning(isCampaignRunning(campaignStatus.value))
    fetchScenarioData()
  }
})

watch(campaignStatus, newValue => {
  if (visible.value) {
    store.setCampaignRunning(isCampaignRunning(newValue))
  }
})

// Expose public methods
expose({
  open: fetchScenarioData,
  close: handleClose
})

return { __sfc: true,proxy, props, visible, prizeId, campaignStatus, emit, store, currentStep, hasCurrentStepErrors, loading, stepLabels, fetchScenarioData, isCampaignRunning, handleClose, handleNext, handleBack, handleSave, handleCancel, Icon, Steps, StepFollowCheck, StepLottery, StepMessage, StepResult }
}

})